import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import PollShowcaseItem from './PollShowcaseItem';
import Placeholder from 'flarum/common/components/Placeholder';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
export default class PollShowcase extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    // States are already refreshed by PollsShowcasePage.
  }
  view() {
    const activeItems = this.showcaseItems();
    const endedItems = this.endedItems();
    return m("div", {
      className: "PollShowcase"
    }, m("div", {
      className: "PollShowcase--active"
    }, m("h2", {
      className: "PollShowcase-title PollShowcase-title--active"
    }, app.translator.trans('fof-polls.forum.showcase.active-polls')), activeItems.toArray(), !this.attrs.activeState.isLoading() && activeItems.toArray().length === 0 && m(Placeholder, {
      text: app.translator.trans('fof-polls.forum.showcase.no-active-polls')
    })), m("div", {
      className: "PollShowcase--ended"
    }, m("h2", {
      className: "PollShowcase-title PollShowcase-title--ended"
    }, app.translator.trans('fof-polls.forum.showcase.ended-polls')), endedItems.toArray(), !this.attrs.endedState.isLoading() && endedItems.toArray().length === 0 && m(Placeholder, {
      text: app.translator.trans('fof-polls.forum.showcase.no-recent-polls')
    }), this.attrs.endedState.hasNext() && m(Button, {
      className: "Button",
      loading: this.attrs.endedState.isLoadingNext(),
      onclick: () => this.attrs.endedState.loadNext()
    }, app.translator.trans('core.forum.discussion_list.load_more_button'))));
  }
  showcaseItems() {
    const items = new ItemList();
    if (this.attrs.activeState.isLoading()) {
      items.add('loading', m(LoadingIndicator, {
        size: "large"
      }));
      return items;
    }
    this.attrs.activeState.getPages().forEach(page => {
      page.items.forEach(poll => {
        items.add('poll-active-' + poll.id(), m(PollShowcaseItem, {
          poll: poll
        }));
      });
    });
    return items;
  }
  endedItems() {
    const items = new ItemList();
    if (this.attrs.endedState.isLoading()) {
      items.add('loading', m(LoadingIndicator, {
        size: "large"
      }));
      return items;
    }
    this.attrs.endedState.getPages().forEach(page => {
      page.items.forEach(poll => {
        items.add('poll-ended-' + poll.id(), m(PollShowcaseItem, {
          poll: poll
        }));
      });
    });
    return items;
  }
}
flarum.reg.add('fof-polls', 'forum/components/Poll/PollShowcase', PollShowcase);